import React from 'react';
import { Box, Icon } from '@material-ui/core';

import useStyles from './styles';

const AvatarProfile = props => {
  const { avatar, className, name } = props;
  const classes = useStyles(props);

  return (
    <Box {...props} className={`${className} ${classes.container}`}>
      {avatar ? (
        <img className="avatar-img" src={avatar} alt={name} />
      ) : (
        <Icon className="avatar-icon">person</Icon>
      )}
    </Box>
  );
};

export default AvatarProfile;
